import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StaticPagesRoutingModule } from './static-pages-routing.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { TermsNConditionsComponent } from './terms-n-conditions/terms-n-conditions.component';
import { ResponsibleGamingComponent } from './responsible-gaming/responsible-gaming.component';
import { SharedModule } from 'src/app/@shared/shared.module';
import { CelebsLoveUsComponent } from './celebs-love-us/celebs-love-us.component';


@NgModule({
  declarations: [
    AboutUsComponent,
    TermsNConditionsComponent,
    ResponsibleGamingComponent,
    CelebsLoveUsComponent
  ],
  imports: [
    CommonModule,
    StaticPagesRoutingModule,
    SharedModule
  ]
})
export class StaticPagesModule { }
